import { renderCheckboxField } from "./handlers/checkbox.ts";
import { renderCheckboxGroupField } from "./handlers/checkbox-group.ts";
import { renderConfirmField } from "./handlers/confirm.ts";
import { renderContentField } from "./handlers/content.ts";
import { renderDateTimeField } from "./handlers/datetime.ts";
import { renderEmailField } from "./handlers/email.ts";
import { renderHiddenField } from "./handlers/hidden.ts";
import { renderNumberField } from "./handlers/number.ts";
import { renderPhoneField } from "./handlers/phone.ts";
import { renderRadioGroupField } from "./handlers/radio-group.ts";
import { renderSelectField } from "./handlers/select.ts";
import { renderTextField } from "./handlers/text.ts";
import { renderWebsiteField } from "./handlers/website.ts";
import type { FieldRenderers, FieldType, RenderContext, RenderField } from "./types.ts";

export const fieldRenderers: FieldRenderers = {
  CHECKBOX: renderCheckboxField,
  CHECKBOX_GROUP: renderCheckboxGroupField,
  CONFIRM: renderConfirmField,
  CONTENT: renderContentField,
  DATETIME: renderDateTimeField,
  EMAIL: renderEmailField,
  HIDDEN: renderHiddenField,
  NUMBER: renderNumberField,
  PHONE: renderPhoneField,
  RADIO_GROUP: renderRadioGroupField,
  SELECT: renderSelectField,
  TEXT: renderTextField,
  WEBSITE: renderWebsiteField,
};

/**
 * Dispatches a field to its typed handler. The generic parameter keeps the
 * field and its handler aligned to the same type key, so no assertion is
 * needed to satisfy the registry lookup.
 */
export const renderField = <K extends FieldType>(
  field: RenderField<K>,
  context: RenderContext,
): HTMLElement => {
  const handler = fieldRenderers[field.type];

  return handler(field, context);
};
